import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { MobileSidebarSideBarAction } from "../../Redux/Action";
import { useNavigate } from "react-router-dom";
function SidebarLeft() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const [CheckSidebarForOpen, SetCheckSidebarForOpen] = useState(true);
  const { CheckSidebarOpen, CheckMobileSidebarOpen } = useSelector((state) => {
    return {
      CheckSidebarOpen: state.Header.CheckSidebarOpen,
      CheckMobileSidebarOpen: state.Header.CheckMobileSidebarOpen,
    };
  });
  useEffect(() => {
    SetCheckSidebarForOpen(CheckSidebarOpen);
    // if(CheckSidebarOpen){
    //     return navigate("/Overview"); ///  Payment Gateway
    // }else{
    //     return navigate("/Introduction"); ///  Neo Banking
    // }
  }, [CheckSidebarOpen]);
  useEffect(() => {
    setIsOpen(CheckMobileSidebarOpen);
  }, [CheckMobileSidebarOpen]);
  return (
    <div className="idocs-navigation bg-light">
      <ul className="nav flex-column ">
        <Sidebar breakPoint="lg" toggled={isOpen}>
          {CheckSidebarForOpen ? (
            <>
              {/* Payment Gateway Sidebar Start */}

              {/* payment gateway new */}
              <Menu>
                <Link to="/Introduction">
                  <MenuItem>Introduction</MenuItem>
                </Link>

                <Link to="/Enviroments">
                  <MenuItem>Enviroments</MenuItem>
                </Link>

                <Link to="/ProcessFlowIntegrationMethods">
                  <SubMenu label="Process Flow Integration Methods">
                    <Link to="/AggHostedNonSeamless">
                      <MenuItem> Aggregator Hosted (Non-Seamless)</MenuItem>
                    </Link>

                    <Link to="/MerchantHostedSeamless">
                      <MenuItem>Merchant Hosted (Seamless)</MenuItem>
                    </Link>

                    {/* <Link to="/AggregatorHostedwithPaymode">
                      <MenuItem>Aggregator with Paymode Hosted</MenuItem>
                    </Link> */}

                    <Link to="/JSCheckOutInternational">
                      <MenuItem>JS Checkout</MenuItem>
                    </Link>

                    <Link to="/APIIntegration">
                      <MenuItem>API Integration</MenuItem>
                    </Link>
                  </SubMenu>
                </Link>

                <Link to="/IntegrationwithSafexPay">
                  <MenuItem> Integration with SafexPay</MenuItem>
                </Link>

                {/* <Link to="/GooglePay"> */}
                  <SubMenu label="Wallets Available">
                    <Link to="/GooglePay">
                      <MenuItem>Google Pay</MenuItem>
                    </Link>
                    

                    {/* <Link to="/SamsungPay">
                      <MenuItem>Samsung Pay</MenuItem>
                    </Link> */}
                  {/* 
                    <Link to="/ApplePay">
                      <MenuItem>Apple Pay</MenuItem>
                    </Link> */}
                  </SubMenu>
                  
                {/* </Link> */}

                  <Link to="/RedirectCheckoutPlugins">
                  <SubMenu label="Redirect Checkout & Plugins">
                    <MenuItem> Server side integration</MenuItem>
                  </SubMenu>
                </Link>


                <Link to="/MovingtoLives">
                  <MenuItem>Moving to LIVE</MenuItem>
                </Link>

                <Link to="/StatusAPIPg">
                  <MenuItem> Status API</MenuItem>
                </Link>

               

                <Link to="/RefundsAPI">
                  <MenuItem>Refund API</MenuItem>
                </Link>

                <Link to="/WebhookAPI">
                  <MenuItem>Webhook API</MenuItem>
                </Link>

                <Link to="/Linkbasedapi">
                  <MenuItem>Link Based API</MenuItem>
                </Link>


                <Link to="/VoidApi">
                  <MenuItem>Void API</MenuItem>
                </Link>

               



                <Link to="/RefundsProcessing">
                  <MenuItem>Refunds Processing</MenuItem>
                </Link>

                <Link to="/TransactionResponseCodes">
                  <MenuItem>Transaction Response Codes</MenuItem>
                </Link>

                <Link to="/FAQs">
                  <MenuItem>FAQ’s</MenuItem>
                </Link>

                {/* <Link to="/OurSupport">
                  <MenuItem>Get In Touch With Our Support Teams</MenuItem>
                </Link> */}




                {/* payment gateway new end*/}

                {/* <Link to="/GetStarted">
                  <SubMenu label="Get Started">
                    <MenuItem> How to Sign In/Sign Up</MenuItem>
                  </SubMenu>
                </Link> */}

                {/* 
                <Link to="/Dashboard">
                  <SubMenu label="Dashboard">
                    <MenuItem>Home Page Detail</MenuItem>
                    <MenuItem>Test & Live Mode</MenuItem>
                    <MenuItem>Reports</MenuItem>
                  </SubMenu>
                </Link> */}

                {/* <Link to="/PaymentModesAvailable">
                  <MenuItem>Available Pay Modes</MenuItem>
                </Link> */}

                {/* <Link to="/Settlements">
                  <SubMenu label="Settlements">
                    <MenuItem> Instant Settlement</MenuItem>
                    <MenuItem> Split Settlement </MenuItem>
                    <MenuItem> On Demand Settlement </MenuItem>
                  </SubMenu>
                </Link> */}

                {/* <Link to="/Refunds">
                  <MenuItem>Refunds</MenuItem>
                </Link> */}

                {/* <Link to="/PaymentLinks">
                  <MenuItem>Payment Links</MenuItem>
                </Link> */}

                {/* <Link to="/PaymentButton">
                  <MenuItem>Payment Button</MenuItem>
                </Link> */}

                {/* <Link to="/Invoices">
                  <MenuItem>Invoices</MenuItem>
                </Link> */}

                {/* <Link to="/QRCodes">
                  <MenuItem>QR Codes</MenuItem>
                </Link> */}

                {/* <Link to="/SmartCollect">
                  <MenuItem>Smart Collect</MenuItem>
                </Link> */}

              

                {/* <Link to="/PaymentIntegration">
                  <SubMenu label="Payment Integration">
                    <MenuItem> Aggregator Hosted (Non-Seamless)</MenuItem>
                    <MenuItem> Merchant Hosted (Seamless)</MenuItem>
                    <MenuItem> Aggregator with Paymode Hosted</MenuItem>
                  </SubMenu>
                </Link> */}

                {/* <Link to="/JSCheckout">
                  <SubMenu label="JS Checkout">
                    <MenuItem>
                      {" "}
                      JS Checkout – Secure and Modern Payment Solution
                    </MenuItem>
                  </SubMenu>
                </Link> */}

                {/* <Link to="/ECollectAPI">
                  <SubMenu label="E-Collect API">
                    <MenuItem>Create VAN</MenuItem>
                    <MenuItem>Close VAN</MenuItem>
                    <MenuItem>Fetch Transaction</MenuItem>
                    <MenuItem> Fetch VAN list</MenuItem>
                  </SubMenu>
                </Link> */}

                {/*                 
                <Link to="/ValidateVPAAPI">
                  <SubMenu label="Validate VPA API">
                    <MenuItem>Validate VPA API</MenuItem>
                  </SubMenu>
                </Link> */}

                {/* <Link to="/StatusAPI">
                  <SubMenu label="Status API">
                    <MenuItem>Status API Integration</MenuItem>
                  </SubMenu>
                </Link> */}

                {/* <Link to="/RefundAPI">
                  <SubMenu label="Refund API">
                    <MenuItem>
                      You can use the Refund API to initiate the refund
                    </MenuItem>
                  </SubMenu>
                </Link> */}

                {/* <Link to="/ResellerAPI">
                  <SubMenu label="Reseller API">
                    <MenuItem>GET Merchant List API</MenuItem>
                    <MenuItem>GET Transaction MIS API</MenuItem>
                  </SubMenu>
                </Link> */}

                {/* <Link to="/TransactionMIS">
                  <SubMenu label="Transaction MIS">
                    <MenuItem>Login API</MenuItem>
                    <MenuItem>Transaction MIS/ Details Summary</MenuItem>
                    <MenuItem>Get Transaction Detail API</MenuItem>
                  </SubMenu>
                </Link> */}

                {/* <Link to="/SettlementMISAPI">
                  <SubMenu label="Settlement MIS API">
                    <MenuItem>Login API</MenuItem>
                    <MenuItem>Get Settlement MIS Detail API</MenuItem>
                  </SubMenu>
                </Link> */}

                {/* <Link to="/Webhook">
                  <SubMenu label="Webhook">
                    <MenuItem>Webhook response</MenuItem>
                  </SubMenu>
                </Link> */}

                {/* <Link to="/IntegrationAPIforMerchantOnboarding">
                  <SubMenu label="Integration API for Merchant Onboarding">
                    <MenuItem>Merchant Online Onboarding API</MenuItem>
                    <MenuItem>Status API</MenuItem>
                    <MenuItem>Document/KYC Upload API</MenuItem>
                  </SubMenu>
                </Link> */}
              </Menu>
              {/* Payment Gateway Sidebar End */}
            </>
          ) : (
            <>
              {/* Neo Banking Sidebar Start */}
              {/* <Menu>
         <Link to="/Introduction">
            <MenuItem>
               
               Introduction  
            </MenuItem>
            </Link>
            <Link to="/Usecases">
            <MenuItem>
               
               Use Cases  
            </MenuItem>
            </Link>
            <Link to="/FeaturesAndFunctions">
            <MenuItem>
               
               Features And Functions 
            </MenuItem>
            </Link> 
            <Link to="/AvailablePayModes">
            <MenuItem>
               
               Available Pay Modes 
            </MenuItem>
            </Link> 
            <Link to="/PayoutLifecycleandState">
            <MenuItem>
               
               Payout Lifecycle and State 
            </MenuItem>
            </Link> 
            <Link to="/AddFundstoVA">
            <MenuItem>
               
               How to add funds to VA  
            </MenuItem>
            </Link>
            <Link to="/SafexpayPayoutErrorCodes">
            <MenuItem>
               
            Safexpay Payout Error Codes  
            </MenuItem>
            </Link>
            <Link to="/HowtodoPayout">
            <MenuItem>
               
               How to do Payout  
            </MenuItem>
            </Link>
            <Link to="/PayoutSolution">
            <SubMenu label="Payout Solution">
               <MenuItem>Support API's</MenuItem>
               <MenuItem>Transaction Initiation Flow 1</MenuItem>
               <MenuItem>Transaction Initiation Flow 2</MenuItem>
            </SubMenu>
            </Link>
         </Menu> */}
              {/* Neo Banking Sidebar end */}
            </>
          )}
        </Sidebar>
      </ul>
    </div>
  );
}
export default SidebarLeft;
